import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { QuickStepsConfig } from '../store/schema/QuickStepsConfig';

export default mutatorAction('initializeQuickSteps', (quickStepsConfig: QuickStepsConfig) => {
    const store = getStore();
    store.version = quickStepsConfig.version;
    store.quickSteps = quickStepsConfig.quickSteps;
});
